import SkyShopLogo from '../../../../../images/plugins/logo_skyshop.svg';
import ShoperLogo from '../../../../../images/plugins/logo_shoper.svg';
import PrestaShopLogo from '../../../../../images/plugins/logo_prestashop.png';
import SellyLogo from '../../../../../images/plugins/logo_selly.png';
import CairoLogo from '../../../../../images/plugins/logo_cairo.png';

export const resources = [
  {
    id: 1,
    logo: SkyShopLogo,
    plugin: 'skyshop',
    product: ['PURCHASE_FINANCE'],
    title: 'PURCHASE_FINANCE_INTEGRATION',
    description: 'PLUGIN_ACTIVATE_DESCRIPTION_INSTALLMENT',
    link: {
      url: 'https://sky-shop.pl/integracja-z-bramka-pragmago/?utm_source=pragmago&utm_medium=strona&utm_campaign=zaloz_sklep',
      type: 'link',
    },
  },
  {
    id: 2,
    logo: ShoperLogo,
    plugin: 'shoper',
    product: ['PURCHASE_FINANCE'],
    title: 'PURCHASE_FINANCE_INTEGRATION',
    description: 'PLUGIN_ACTIVATE_DESCRIPTION_LINK',
    link: {
      url: 'https://www.shoper.pl/aplikacje/raty-dla-biznesu-z-pragmago/?utm_source=pragmago&utm_medium=link&utm_campaign=partner',
      type: 'link',
    },
  },
  {
    id: 3,
    logo: PrestaShopLogo,
    plugin: 'prestaShop',
    product: ['PURCHASE_FINANCE'],
    title: 'PURCHASE_FINANCE_INTEGRATION',
    description: 'PLUGIN_ACTIVATE_DESCRIPTION_FILE',
    link: {
      url: 'https://pragmago.pl/marketing/partner/wtyczka-prestashop-pragmago.zip',
      type: 'file',
    },
  },
  {
    id: 4,
    logo: SellyLogo,
    plugin: 'selly',
    product: ['PURCHASE_FINANCE', 'DEFERRED_PAYMENT'],
    title: 'PURCHASE_FINANCE_AND_DEFERRED_PAYMENT_INTEGRATION',
    description: 'PLUGIN_ACTIVATE_DESCRIPTION_LINK',
    link: {
      url: 'https://www.selly.pl/baza-wiedzy/integracje/integracja-z-pragmago-odroczona-platnosc-dla-biznesu/',
      type: 'link',
    },
  },
  {
    id: 5,
    logo: CairoLogo,
    plugin: 'cairo',
    product: ['PURCHASE_FINANCE', 'DEFERRED_PAYMENT'],
    title: 'PURCHASE_FINANCE_AND_DEFERRED_PAYMENT_INTEGRATION',
    description: 'PLUGIN_ACTIVATE_DESCRIPTION_LINK',
    link: {
      url: 'https://cairo.partner.pragmago.pl/?utm_source=strefapartnera&utm_medium=link&utm_campaign=plugin&utm_term=p-915760&utm_content=wtyczkacairo',
      type: 'info',
    },
  },
];
